export default __webpack_public_path__ + "./images/sync.24cc6e3b.svg";